import { hasKey } from '../typescript';
import {
    LOCALE_US,
    LOCALE_DE,
    LOCALE_FR,
    LOCALE_IT,
    LOCALE_ES,
    LOCALE_DEBUG,
    LOCALE_PSEUDO,
} from '../locales/constants';
import { type Locale } from '../locales/constants';

export const IN = 'IN';
export const CM = 'CM';
export const MEASUREMENT_UNITS = [IN, CM] as const;
export type MeasurementUnit = typeof MEASUREMENT_UNITS[number];

const supportedMeasurementUnits: Record<Locale, MeasurementUnit> = {
    [LOCALE_US]: IN,
    [LOCALE_DE]: CM,
    [LOCALE_FR]: CM,
    [LOCALE_IT]: CM,
    [LOCALE_ES]: CM,
    [LOCALE_PSEUDO]: IN,
    [LOCALE_DEBUG]: IN,
} as const;

function getMeasurementUnit(locale: string): MeasurementUnit {
    if (hasKey(supportedMeasurementUnits, locale)) {
        return supportedMeasurementUnits[locale];
    } else {
        return IN;
    }
}

const isSupportedMeasurementUnit = (unit: string): unit is MeasurementUnit => {
    return MEASUREMENT_UNITS.includes(unit as MeasurementUnit);
};
const getSupportedMeasurementUnit = (unit: string): MeasurementUnit => {
    if (isSupportedMeasurementUnit(unit)) {
        return unit;
    } else {
        return IN;
    }
};

export { getMeasurementUnit, getSupportedMeasurementUnit };
